import { PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";
import { Typography, Button, Box } from "@mui/material"

interface RequestAccessBlockProps {
  requiredPermission: { action: PermissionActionEnum, entity: PermissionEntityEnum }
  checkRequestExists: (action: PermissionActionEnum, entity: PermissionEntityEnum) => boolean;
  onRequest: (action: PermissionActionEnum, entity: PermissionEntityEnum, projectId?: string) => void;
}

const RequestAccessBlock = ({ requiredPermission, checkRequestExists, onRequest }: RequestAccessBlockProps) => {
  const { action, entity } = requiredPermission;

  if (checkRequestExists(action, entity)) {
    return (
      <Box p={1} display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100%">
        <Typography mb={1}>
          You have already requested this permission. Please await response from the administrator.
        </Typography>
      </Box>
    )
  }

  return (
    <Box p={1} display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100%">
      <Typography mb={1}>
        You don't have the permission to perform this action.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onRequest(action, entity)}
      >
        Request Access
      </Button>
    </Box>
  )
}

export default RequestAccessBlock;
